var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "m-change-status" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.id,
            size: "custom-size",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          on: {
            show: _vm.onShowChangeStatusModal,
            close: function ($event) {
              _vm.localActive = false
            },
          },
          model: {
            value: _vm.localActive,
            callback: function ($$v) {
              _vm.localActive = $$v
            },
            expression: "localActive",
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "m-change-status-close",
              attrs: {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              on: {
                click: function ($event) {
                  _vm.localActive = false
                },
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                  fill: "#8E9CBB",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          ),
          _vm.modalTitle
            ? _c("div", { staticClass: "m-change-status-title" }, [
                _vm._v(" " + _vm._s(_vm.modalTitle) + " "),
              ])
            : _vm._e(),
          _c("div", { staticClass: "m-change-status-fullname" }, [
            _vm._v(_vm._s(_vm.record.fullName.value)),
          ]),
          _c("c-input", {
            staticClass: "m-change-status-select-choice-status",
            class: {
              "m-change-status-select-choice-status-required":
                _vm.localEmployeeStatus === null &&
                _vm.localEmployeeStatusRequiredMessage !== "",
            },
            attrs: {
              label: "Выберите статус",
              type: "select",
              items: _vm.localEmployeeStatusList,
              searchable: true,
              required: _vm.localEmployeeStatusRequiredMessage,
              "required-condition": _vm.localEmployeeStatus === null,
              placeholder: "Выберите статус сотрудника",
            },
            model: {
              value: _vm.localEmployeeStatus,
              callback: function ($$v) {
                _vm.localEmployeeStatus = $$v
              },
              expression: "localEmployeeStatus",
            },
          }),
          _c("transition", { attrs: { name: "fade" } }, [
            _c(
              "div",
              [
                _vm.localEmployeeStatus !== null &&
                _vm.localEmployeeStatus.fired === 1
                  ? _c("c-input", {
                      staticClass: "m-change-status-select-choice-base",
                      class: {
                        "m-change-status-select-choice-base-required":
                          _vm.localEmployeeBaseDismissal === null &&
                          _vm.localEmployeeBaseDismissalRequiredMessage !== "",
                      },
                      attrs: {
                        label: "Основание для увольнения",
                        type: "select",
                        items: _vm.localEmployeeBaseDismissalList,
                        searchable: true,
                        required: _vm.localEmployeeBaseDismissalRequiredMessage,
                        "required-condition":
                          _vm.localEmployeeBaseDismissal === null,
                        "with-special-value": true,
                        placeholder: "Выберите основание для увольнения",
                      },
                      model: {
                        value: _vm.localEmployeeBaseDismissal,
                        callback: function ($$v) {
                          _vm.localEmployeeBaseDismissal = $$v
                        },
                        expression: "localEmployeeBaseDismissal",
                      },
                    })
                  : _vm._e(),
                _c("show-description", {
                  attrs: {
                    value:
                      _vm.localEmployeeBaseDismissal &&
                      _vm.localEmployeeBaseDismissal.descriptionModel,
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.localEmployeeBaseDismissal !== null &&
              _vm.localEmployeeBaseDismissal.specialValue
                ? _c("c-input", {
                    staticClass: "m-change-status-input-cause",
                    attrs: {
                      type: "textarea",
                      "textarea-max-height": "250",
                      "input-text-condition":
                        _vm.localEmployeeBaseDismissalRequiredMessage,
                      placeholder: "Введите причину",
                    },
                    model: {
                      value: _vm.localReasonForDismissal,
                      callback: function ($$v) {
                        _vm.localReasonForDismissal = $$v
                      },
                      expression: "localReasonForDismissal",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "m-change-status-buttons" },
            [
              _c("c-button", {
                attrs: { color: "white", label: "Отменить" },
                on: { click: _vm.closeModal },
              }),
              _c("c-button", {
                attrs: { color: "primary", label: "Применить" },
                on: { click: _vm.changeWorkerStatus },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }